import { useMutation } from '@tanstack/react-query';
import { importFromDoc } from '~api/ai/importFromDoc';

interface UseImportFromDocParams {
  quizId: number;
  workspaceId?: string;
  workspaceQuizId?: string;
  insertionOrder: number;
}

interface UseImportFromDocMutationParams {
  includeExplanation: boolean;
  fileKey: string;
}

export function useImportFromDoc(useParams: UseImportFromDocParams) {
  return useMutation({
    mutationFn: (mutationParams: UseImportFromDocMutationParams) =>
      importFromDoc({
        ...useParams,
        ...mutationParams,
      }),
  });
}
